import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import GlobalThrobberComponent from '../components/global_throbber_component';
import { useNotification } from '../components/global_noification_component';
import '../css/dashboard_page.css';

const API_BASE = process.env.REACT_APP_API_BASE;
const API_VERSION = process.env.REACT_APP_API_ENVIRONMENT;
const OAUTH_PAGE = process.env.REACT_APP_API_DISCORD_OAUTH_PAGE;

export default function DashboardPage() {
  const [selectedSection, setSelectedSection] = useState('Knowledge Base');
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [eligible, setEligible] = useState(false);
  const notify = useNotification();

  useEffect(() => {
    (async () => {
      const token = Cookies.get('refresh_token');
      if (!token) {
        window.location.href = OAUTH_PAGE;
        return;
      }
      try {
        const res = await fetch(`${API_BASE}/${API_VERSION}/public/oAuth/discord/fetch`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code: token, application: 'dashboard' })
        });
        const data = await res.json();
        if (!res.ok) {
          notify('error', data.message || 'Authentication failed');
          window.location.href = OAUTH_PAGE;
          return;
        }
        setUser(data.user);
        setEligible(data.is_in_gym_guild);
      } catch {
        notify('error', 'Failed verifying user');
        window.location.href = OAUTH_PAGE;
        return;
      } finally {
        setLoading(false);
      }
    })();
  }, [notify]);

  const renderContent = () => {
    switch (selectedSection) {
      case 'Profile':
        return (
          <div className="content-panel">
            <h2>Welcome, {user?.global_name || user?.username}</h2>
            <p>ID: {user?.id}</p>
          </div>
        );
      case 'Knowledge Base':
        return (
          <div className="content-panel">
            <h2>Knowledge Base</h2>
            <p>Configure your community help flows here.</p>
          </div>
        );
      default:
        return <div className="content-panel">Select a section from the sidebar.</div>;
    }
  };

  if (loading) {
    return <GlobalThrobberComponent />;
  }

  if (!eligible) {
    return (
      <div className="dashboard-container">
        <div className="main-content">
          <div className="content-panel">
            <p>You are not authorized to access this dashboard.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="sidebar">
        <ul>
          <li
            onClick={() => setSelectedSection('Profile')}
            className={selectedSection === 'Profile' ? 'active' : ''}
          >
            Profile
          </li>
          <li
            onClick={() => setSelectedSection('Knowledge Base')}
            className={selectedSection === 'Knowledge Base' ? 'active' : ''}
          >
            Knowledge Base
          </li>
        </ul>
      </div>
      <div className="main-content">{renderContent()}</div>
    </div>
  );
}
